export default "__VITE_PUBLIC_ASSET__415d489d__"